import { styled, InputBase, inputBaseClasses } from '@mui/material';

export const InputBaseStyled = styled(InputBase)(({ theme }) => ({
  [`& .${inputBaseClasses.input}`]: {
    backgroundColor: 'transparent',
    fontSize: 12,
    padding: '0px 26px 0px 8px',
    borderRight: `1px solid ${theme.palette.grey['200']}`,
  },
  [`& .${inputBaseClasses.input}:focus`]: {
    backgroundColor: 'transparent',
  },
}));
